export default __webpack_public_path__ + "fe201ed3cf72248c3db2e05c6a0fb09c.png";